import React from "react";
import { Error } from ".";
import { envStaticHost } from "../Utils/windowHelper";
import { translate } from "../Utils/language";

type Props = {
  language: string;
  noPackagesToDisplay: boolean;
  referer: string;
};

const SignupNewsLetter: React.FC<Props> = ({ language, noPackagesToDisplay, referer }) => {
  return (
    <div style={{ padding: "2.5rem 0" }}>
      {noPackagesToDisplay && (
        <>
          <Error
            errorImage={`${envStaticHost}/static/${referer}/error/Empty1.png`}
            bodyText={translate(language, "Select your interest")}
            referer={referer}
          />
        </>
      )}
    </div>
  );
};

export default SignupNewsLetter;
